import { Stack } from 'expo-router'
import { stableStackOptions } from '../../../lib/navigation/stable-stack-options'

export default function ToursLayout() {
  return (
    <Stack screenOptions={{ headerShown: false, ...stableStackOptions }}>
      <Stack.Screen name="index" />
      <Stack.Screen name="quote" />
      <Stack.Screen name="[experienceId]" />
    </Stack>
  )
}
